import * as React from "react";
import { forwardRef, memo } from "react";
const SvgOutlinedScanIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: "1rem", height: "1rem", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M9 3H5C3.89543 3 3 3.89543 3 5V9M9 21H5C3.89543 21 3 20.1046 3 19V15M15 3H19C20.1046 3 21 3.89543 21 5V9M21 15V19C21 20.1046 20.1046 21 19 21H15M3 12.0003H21", stroke: "#007AAF", strokeWidth: 1.5, strokeLinecap: "round" }));
const ForwardRef = forwardRef(SvgOutlinedScanIcon);
const Memo = memo(ForwardRef);
export default Memo;
